module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticStyle: {
      "margin-bottom": "1em",
      "margin-left": "0em"
    }
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rded"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/006_dedication#ded"
    }
  }, [_vm._v("DEDICATION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rack"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007_acknowledgements#ack"
    }
  }, [_vm._v("ACKNOWLEDGEMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/008_chapter1#ch1"
    }
  }, [_vm._v("CHAPTER 1")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009_chapter2#ch2"
    }
  }, [_vm._v("CHAPTER 2")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010_chapter3#ch3"
    }
  }, [_vm._v("CHAPTER 3")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/011_chapter4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 4")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/012_chapter5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 5")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/013_chapter6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 6")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/014_chapter7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 7")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/015_chapter8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 8")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/016_chapter9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 9")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/017_chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 10")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/018_chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 11")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/019_chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 12")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/020_chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 13")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/021_chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 14")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/022_chapter15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 15")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/023_chapter16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 16")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/024_chapter17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 17")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/025_chapter18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 18")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/026_chapter19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 19")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/027_chapter20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 20")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/028_chapter21#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 21")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/029_chapter22#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 22")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/030_chapter23#ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 23")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/031_chapter24#ch24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 24")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/032_chapter25#ch25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 25")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/033_chapter26#ch26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 26")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/034_chapter27#ch27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 27")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/035_chapter28#ch28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 28")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/036_chapter29#ch29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 29")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/037_chapter30#ch30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 30")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/038_chapter31#ch31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 31")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/039_chapter32#ch32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 32")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/040_chapter33#ch33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 33")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/041_chapter34#ch34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 34")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/042_chapter35#ch35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 35")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/043_chapter36#ch36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 36")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/044_chapter37#ch37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 37")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/045_chapter38#ch38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EPILOGUE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/046_chapter39#ch39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GEMINI RISING")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/047_chapter40#ch40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NEXT LIFETIME")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rser"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/048_series#ser",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ABOUT THE KINGS OF THE CASTLE SERIES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "raut"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/049_author#aut",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AUTHOR BIOS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rmen"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/050_mentors#men",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SERIES MENTORS:")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1df08f6a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005_contents.vue
// module id = 66
// module chunks = 0